{
    "firstLevel": [
        {
            "secondId": 1,
            "name": "contact-us.call-me-back.topic-claim"
        },
        {
            "secondId": 2,
            "name": "contact-us.call-me-back.topic-insurance"
        },
        {
            "secondId": 3,
            "name": "contact-us.call-me-back.topic-policy"
        },
        {
            "secondId": 4,
            "name": "contact-us.call-me-back.topic-other"
        }
    ],
    "secondLevel": [
        {
            "id": 774,
            "firstId": 1,
            "key": "topic-file-claim",
            "name": "inbox.email-us.subtopic.topic-file-claim",
            "notification": true
        },
        {
            "id": 774,
            "firstId": 1,
            "key": "topic-track-claim",
            "name": "inbox.email-us.subtopic.topic-track-claim",
            "notification": true
        },
        {
            "id": 774,
            "firstId": 1,
            "key": "topic-other-claim",
            "name": "inbox.email-us.subtopic.topic-other-claim",
            "notification": false
        },

        {
            "id": 127,
            "firstId": 2,
            "key": "topic-insurance-life",
            "name": "inbox.email-us.subtopic.topic-insurance-life",
            "notification": false
        },
        {
            "id": 127,
            "firstId": 2,
            "key": "topic-insurance-property",
            "name": "inbox.email-us.subtopic.topic-insurance-property",
            "notification": true
        },
        {
            "id": 127,
            "firstId": 2,
            "key": "topic-insurance-car",
            "name": "inbox.email-us.subtopic.topic-insurance-car",
            "notification": true
        },
        {
            "id": 127,
            "firstId": 2,
            "key": "topic-insurance-travel",
            "name": "inbox.email-us.subtopic.topic-insurance-travel",
            "notification": true
        },
        {
            "id": 127,
            "firstId": 2,
            "key": "topic-insurance-moutain",
            "name": "inbox.email-us.subtopic.topic-insurance-moutain",
            "notification": true
        },
        {
            "id": 127,
            "firstId": 2,
            "key": "topic-insurance-damage-employer",
            "name": "inbox.email-us.subtopic.topic-insurance-damage-employer",
            "notification": true
        },
        {
            "id": 127,
            "firstId": 2,
            "key": "topic-insurance-legal-protection",
            "name": "inbox.email-us.subtopic.topic-insurance-legal-protection",
            "notification": false
        },
        {
            "id": 127,
            "firstId": 2,
            "key": "topic-insurance-other",
            "name": "inbox.email-us.subtopic.topic-insurance-other",
            "notification": false
        },

        {
            "id": 127,
            "firstId": 3,
            "key": "topic-insurance-supplementary",
            "name": "inbox.email-us.subtopic.topic-insurance-supplementary",
            "notification": false
        },
        {
            "id": 3,
            "firstId": 3,
            "key": "topic-policy-update",
            "name": "inbox.email-us.subtopic.topic-policy-update",
            "notification": false
        },
        {
            "id": 3,
            "firstId": 3,
            "key": "topic-policy-information",
            "name": "inbox.email-us.subtopic.topic-policy-information",
            "notification": false
        },
        {
            "id": 3,
            "firstId": 3,
            "key": "topic-policy-payment-status",
            "name": "inbox.email-us.subtopic.topic-policy-payment-status",
            "notification": true
        },
        {
            "id": 3,
            "firstId": 3,
            "key": "topic-policy-cancel",
            "name": "inbox.email-us.subtopic.topic-policy-cancel",
            "notification": false
        },
        {
            "id": 3,
            "firstId": 3,
            "key": "topic-policy-other",
            "name": "inbox.email-us.subtopic.topic-policy-other",
            "notification": false
        },

        {
            "id": 13,
            "firstId": 4,
            "key": "topic-other-suggestion",
            "name": "inbox.email-us.subtopic.topic-other-suggestion",
            "notification": false
        },
        {
            "id": 13,
            "firstId": 4,
            "key": "topic-other-compliment",
            "name": "inbox.email-us.subtopic.topic-other-compliment",
            "notification": false
        },
        {
            "id": 13,
            "firstId": 4,
            "key": "topic-other-complaint",
            "name": "inbox.email-us.subtopic.topic-other-complaint",
            "notification": false
        },
        {
            "id": 13,
            "firstId": 4,
            "key": "topic-other-other",
            "name": "inbox.email-us.subtopic.topic-other-other",
            "notification": false
        }
    ]
}